gsap.registerPlugin(ScrollTrigger);

gsap.from(".roadmap-wojak", {
    scrollTrigger: {
        trigger: ".roadmap",
        scrub: true,
        start: "top top",
        end: "+=100%"
    },
    translateX: 1500,
    rotate: 400,
    ease: "none"
});

var timelineHeight = document.querySelector('.roadmap-timeline').offsetHeight;

gsap.to(".timeline-wojak", {
    scrollTrigger: {
        trigger: ".roadmap",
        scrub: true,
        start: "top top",
        end: "bottom top"
    },
    y: timelineHeight,
    rotate: 400,
    ease: "none"
});